import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const menuGroups = {
    company: [
        ['About Us', '/about'],
        ['Contact Us', '/contact'],
        ['Career', '/career'],
        ['Leadership', '/leadership'],
        ['Partners', '/partners'],
    ],
    technology: [
        ['Zero Trust', '/zero-trust'],
        ['SOAR', '/soar'],
        ['Artificial Intelligence', '/artificial-intelligence'],
        ['Machine Learning', '/machine-learning'],
        ['Deception Technology', '/deception-technology'],
    ],
    resources: [
        ['Case Studies', '/'],
        ['Data Sheets', '/'],
        ['White Papers', '/'],
        // ['Upcoming Events', '/'],
        // ['Videos', '/'],
        ['Blogs', '/blog/zero-trust-blog'],
    ],

};

const productGroups = [
    {
        title: 'Products', icon: 'fa-shield-alt', items: [
            ['Enterprise Mobility & Security', '/enterprise-mobility-security'],
            ['Enterprise Network Services & NDR', '/enterprise-network-ndr'],
            ['Digital Workspace Management', '/digital-workspace'],
            ['Enterprise Data Management & Security', '/data-management'],
        ]
    },
    {
        title: 'Coverage Areas', icon: 'fa-layer-group', items: [
            ['Cloud', '/cloud'], ['Network', '/enterprise-network-ndr'],
            ['Email', '/email'], ['Endpoint', '/endpoint'],
        ]
    },
    {
        title: 'Use Cases', icon: 'fa-bullseye', items: [
            ['EDR', '/'], ['Microsoft', '/'], ['Ransomware', '/ransomware'],
        ]
    },
];

const HeaderNavbar = () => {
    const [activeMenu, setActiveMenu] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);

    const closeMenus = () => {
        setActiveMenu(null);
        setMobileOpen(false);
    };

    const dropdown = (name, label) => (
        <li className="cm-nav-item" onMouseEnter={() => setActiveMenu(name)} onMouseLeave={() => setActiveMenu(null)}>
            <button className="cm-nav-link" type="button" onClick={() => setActiveMenu(activeMenu === name ? null : name)}>
                {label}<i className={`fa fa-angle-down ${activeMenu === name ? 'is-open' : ''}`} aria-hidden="true" />
            </button>
            <div className={`cm-dropdown ${activeMenu === name ? 'is-visible' : ''}`}>
                {menuGroups[name].map(([text, path]) => (
                    <Link to={path} onClick={closeMenus} key={`${name}-${text}`}><span>{text}</span><i className="fa fa-arrow-right" /></Link>
                ))}
            </div>
        </li>
    );

    return (
        <header className="cm-header">
            <nav className="cm-navbar" aria-label="Main navigation">
                <div className="container cm-header-container cm-navbar-inner">
                    <Link className="cm-logo" to="/" onClick={closeMenus}>
                        <img src={require('../assets/images/logo.png')} alt="CloudMind" />
                    </Link>

                    <button className="cm-menu-toggle" type="button" aria-label="Toggle navigation" aria-expanded={mobileOpen} onClick={() => setMobileOpen(!mobileOpen)}>
                        <span /><span /><span />
                    </button>

                    <div className={`cm-nav-panel ${mobileOpen ? 'is-open' : ''}`}>
                        <ul className="cm-nav-list">
                            <li className="cm-nav-item"><Link className="cm-nav-link" to="/" onClick={closeMenus}>Home</Link></li>
                            {dropdown('company', 'Company')}
                            {dropdown('technology', 'Technology')}
                            <li className="cm-nav-item cm-products" onMouseEnter={() => setActiveMenu('products')} onMouseLeave={() => setActiveMenu(null)}>
                                <button className="cm-nav-link" type="button" onClick={() => setActiveMenu(activeMenu === 'products' ? null : 'products')}>
                                    Products<i className={`fa fa-angle-down ${activeMenu === 'products' ? 'is-open' : ''}`} />
                                </button>
                                <div className={`cm-mega-menu ${activeMenu === 'products' ? 'is-visible' : ''}`}>
                                    <div className="cm-mega-intro">
                                        <span className="cm-mega-kicker">Our solutions</span>
                                        <h3>Security built for the modern enterprise.</h3>
                                        <p>Explore connected solutions that protect every layer of your digital business.</p>
                                        <Link to="/contact" onClick={closeMenus}>Talk to an expert <i className="fa fa-arrow-right" /></Link>
                                    </div>
                                    <div className="cm-mega-groups">
                                        {productGroups.map(group => (
                                            <div className="cm-mega-group" key={group.title}>
                                                <div className="cm-mega-heading"><span><i className={`fa ${group.icon}`} /></span>{group.title}</div>
                                                {group.items.map(([text, path]) => <Link to={path} onClick={closeMenus} key={text}>{text}<i className="fa fa-chevron-right" /></Link>)}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </li>
                            {dropdown('resources', 'Resources')}
                        </ul>
                        <Link className="cm-header-cta" to="/contact" onClick={closeMenus}>Request a Demo <span><i className="fa fa-arrow-right" /></span></Link>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default HeaderNavbar;
